// HTTP wrapper for the per-(user, connection) database-visibility list.
// Hidden DBs are filtered out of the sidebar tree but still exist on the server.
import { api } from './api.js';

export async function loadHiddenDatabases(connectionId) {
  try {
    const r = await api.get(`/api/connections/${connectionId}/database-visibility`);
    return r.hidden || [];
  } catch {
    return [];
  }
}

export async function saveHiddenDatabases(connectionId, hidden) {
  return api.put(`/api/connections/${connectionId}/database-visibility`, { hidden });
}
